import { TAXPRO_NOTES_ACTION_TYPE } from './Type';

const INITIAL_STATE = {
	// Map of `${taxproUserId}:${type ?? 'all'}` → { notes, total, loading, error }
	byKey: {},
};

const taxproNotesReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case TAXPRO_NOTES_ACTION_TYPE.setLoading: {
			const { key, loading } = action.payload;
			return {
				...state,
				byKey: {
					...state.byKey,
					[key]: { ...(state.byKey[key] || {}), loading, error: null },
				},
			};
		}
		case TAXPRO_NOTES_ACTION_TYPE.setNotes: {
			const { key, notes, total } = action.payload;
			return {
				...state,
				byKey: {
					...state.byKey,
					[key]: { notes, total, loading: false, error: null },
				},
			};
		}
		case TAXPRO_NOTES_ACTION_TYPE.setError: {
			const { key, error } = action.payload;
			return {
				...state,
				byKey: {
					...state.byKey,
					[key]: { ...(state.byKey[key] || {}), loading: false, error },
				},
			};
		}
		case TAXPRO_NOTES_ACTION_TYPE.clearNotes: {
			const { key } = action.payload;
			const next = { ...state.byKey };
			delete next[key];
			return { ...state, byKey: next };
		}
		default:
			return state;
	}
};

export default taxproNotesReducer;
